import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { AfterViewInit, Component, OnInit } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { DealerService } from "./../../../../../services/seed/dealer.service";
import { LoaderService } from './../../../../../services/infrastructure/loader.service';
import { CommonService } from './../../../../../services/common/common.service';
import { BroadcastService } from './../../../../../services/infrastructure/broadcaster.service';
import { LocalStorageService } from './../../../../../services/infrastructure/local-storage.service';
import { EaAddProductSliderModelService } from '../ea-add-product/ea-add-product-slider-model.service';
import { Subscription } from 'rxjs';
import { FilterOption } from '../../../../../common/components/filter/filter-model';
import { LolLoggerService } from '../../../../../common/shared/lol-logger.service';
import { MasterConstants } from '../../../../../common/constants/master-constants';
import { ControlType } from '../../../../../common/components/filter/filter-enum';
import { ConfigService } from '../../../../../services/infrastructure/config.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-ea-add-product',
  templateUrl: './ea-add-product.component.html',
  styleUrls: ['./ea-add-product.component.scss']
})
export class EaAddProductComponent implements OnInit, AfterViewInit {
  private subscription = new Array<Subscription>();
  eaAddProductDS: MatTableDataSource<any>;
  eaModifyProductDSCopy: any;
  displayColumns: string[] = ['productName', 'packageSize', 'seedSize', 'technology', 'treatment', 'maturity', 'productLine', 'dealerUnits', 'eaUnits'];
  eaAddFilters: any;
  totalEaUnits: number = 0;
  accountNo: number;
  dealerOrderId: number;
  companyCode: string;
  cropYear: number;
  isDisplayDealerUnitsChecked: boolean = true;
  filterOptionsData: Array<FilterOption>;
  errorMsgs = new Array();
  showErrorBlock
  currentErrorRow = 1;
  nextErrorId = 0;
  isupdate: boolean = true;
  index = 0;
  globalKey = { 'Values': [] };
  constructor(private eaAddProductSliderModelService: EaAddProductSliderModelService,
    private dealerService: DealerService,
    private toastrService: ToastrService,
    private broadcastService: BroadcastService,
    public commonService: CommonService,
    private configService: ConfigService,
    private router: Router,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService) { }

  ngOnInit(): void {
    // Set Data
    this.subscription.push(this.eaAddProductSliderModelService.initializeProductChangeValue.subscribe(x => {
      this.accountNo = x.accountNo;
      this.companyCode = x.companyCode;
      this.cropYear = x.cropYear;
      this.eaAddProductSliderModelService.initializeProductChangeValue.observers = [];
    }));

    // DealerOrder Id
    this.dealerOrderId = this.dealerService.selectedDealerOrderId;
    // Set Filters
    this.setFilterData();
  }

  // save eaunits for backup
  saveInStorage(item: any) {
    this.globalKey.Values = this.globalKey.Values.length > 0 ? this.globalKey.Values : [];
    const index = this.globalKey.Values.findIndex(z => z.itemID == item.itemID);
    if (item.eaUnits == 0 || item.lineErrors.errors.length > 0) {
      if (index != -1) {
        this.globalKey.Values.splice(index, 1);
      }
    }
    else if (item.eaUnits > 0 && item.lineErrors.errors.length == 0) {
      if (index != -1) {
        this.globalKey.Values[index].eaUnits = item.eaUnits;
      }
      else {
        let tempObj = {
          'itemID': item.itemID,
          'eaUnits': item.eaUnits,
          'dealerOrderItemId': item.dealerOrderItemId,
          'uom': item.uom,
          'packSizeDescription': item.packageSize,
          'secondaryUom': item.secondaryUom,
        }
        this.globalKey.Values.push(tempObj)
      }
    }
  }

  setFilterData() {
    this.filterOptionsData = [
      {
        label: 'Product Name',
        key: 'productName',
        controlType: ControlType.Text,
      },
      {
        label: 'Marketing Brand',
        key: 'marketingBrand',
        controlType: ControlType.DropDown,
        controlDataBindLabel: 'value',
        controlDataBindValue: 'id',
      },
      {
        label: 'Seed Size',
        key: 'seedSize',
        controlType: ControlType.DropDown,
        controlDataBindLabel: 'value',
        controlDataBindValue: 'id',
      },
      {
        label: 'Package Size',
        key: 'packageSize',
        controlType: ControlType.DropDown,
        controlDataBindLabel: 'value',
        controlDataBindValue: 'id',
      },
      {
        label: 'Technology',
        key: 'technology',
        controlType: ControlType.DropDown,
        controlDataBindLabel: 'value',
        controlDataBindValue: 'id',
      },
      {
        label: 'Treatment',
        key: 'treatment',
        controlType: ControlType.DropDown,
        controlDataBindLabel: 'value',
        controlDataBindValue: 'id',
      },
      {
        label: 'Item Number',
        key: 'itemNumber',
        controlType: ControlType.DropDown,
        controlDataBindLabel: 'value',
        controlDataBindValue: 'value',
      },
      {
        label: 'Product Line',
        key: 'productLine',
        controlType: ControlType.DropDown,
        controlDataBindLabel: 'value',
        controlDataBindValue: 'id',
      }
    ];

    this.setFilterDropDownData();
  }

  // Search Action
  filterSearchClick(event) {
    this.eaAddFilters = event;
    this.getEaProductsList();
  }

  // Get Data from checkbox
  loadDealerToItems(event) {
    if (event.checked) {
      this.isDisplayDealerUnitsChecked = true;
    }
    else {
      this.isDisplayDealerUnitsChecked = false;
    }
  }

  // update EA Units order
  updateOrder() {
    let payload = []
    if (this.globalKey.Values && this.globalKey.Values.length > 0) {
      let data = this.globalKey.Values.filter(x => x.eaUnits > 0);
      if (data && data.length > 0) {
        data.map((x) => {
          let tempObj = {
            'itemID': x.itemID,
            'eaUnits': x.eaUnits,
            'dealerOrderItemId': x.dealerOrderItemId,
            'uom': x.uom,
            'packSizeDescription': x.packSizeDescription,
            'secondaryUom': x.secondaryUom,
          }
          payload.push(tempObj)
        })
        var postData = {
          cropYear: this.cropYear,
          accountNumber: this.accountNo,
          companyCode: this.companyCode,
          dealerorderId: this.dealerOrderId,
          eaAddItems: payload
        };

        this.loaderService.setLoaderStatus(true);
        this.subscription.push(this.dealerService.eaAddUpdateOrder(postData)
          .subscribe(result => {
            if (result && result.status == true) {
              this.toastrService.success(result.message);
              this.globalKey.Values = [];
              this.eaAddProductSliderModelService.close();
              this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
              this.router.navigate(['/orders/dealer-order-view', 0, result.dealerOrderId, this.accountNo]);
            }
            this.loaderService.setLoaderStatus(false);
          }, (error => {
            LolLoggerService.error(error);
            this.loaderService.setLoaderStatus(false);
          })));
      }
    }
  }

  // Clear All Action
  filterClearAllClick(event) {
    this.eaAddFilters = event;
    this.getEaProductsList();
  }
  // Bind Prevoius Data
  bindDataSource(orderListDS: any, isClone: boolean) {
    if (orderListDS && orderListDS != null) {
      this.eaAddProductDS = new MatTableDataSource(orderListDS);
      if (isClone) {
        this.eaModifyProductDSCopy = JSON.parse(JSON.stringify(orderListDS));
      }
    }
    this.setCount();
  }

  // Increase and Decrease EA Units
  dealerUnitChange(action: string, productItem: any) {
    if (!productItem.eaUnits) {
      productItem.eaUnits = 0;
    }
    if (action == 'decrease') {
      const decValue = +productItem.eaUnits - 1;
      if (decValue > 0) {
        const valueBeforeDec = productItem.eaUnits;
        productItem.eaUnits = Math.floor(productItem.eaUnits / +productItem.conv) * +productItem.conv;
        if (valueBeforeDec == productItem.eaUnits) {
          productItem.eaUnits = (+productItem.eaUnits > +productItem.conv ? +productItem.eaUnits - +productItem.conv : 0);
        }
      }
      else {
        productItem.eaUnits = 0;
      }
    }
    else {
      var valueBeforeInc = productItem.eaUnits;
      productItem.eaUnits = Math.ceil(productItem.eaUnits / +productItem.conv) * +productItem.conv;
      if (valueBeforeInc == productItem.eaUnits) {
        productItem.eaUnits = (+productItem.eaUnits + +productItem.conv);
      }
    }
    this.validateLineItem(productItem);
  }

  // Validations of Errors
  validateLineItem(item: any) {
    if (item.eaUnits != 0 && item.eaUnits % item.conv != 0 && item.conv > 0) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'conv');
      item.lineErrors.errors.push({ id: 'conv', error: 'Please re-enter your EA Units in multiples of ' + item.conv });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'conv');
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
      this.saveInStorage(item);
    }
    if (item.lineErrors.errors.length > 0) {
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
      this.errorMsgs.push(item.lineErrors);
    }
    else {
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
    }

    this.errorMsgs.sort(function (row1, row2) {
      return row1.rowId - row2.rowId;
    });
    this.getCommonErrors(this.errorMsgs);
    this.setCount();
  }

  // Hide & show common error
  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.errorMsgs = [];
      this.index = 0;
      this.currentErrorRow = 1;
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    }
    else {
      this.showErrorBlock
    }
  }

  // Revert all changes
  revertAllChanges() {
    this.revertToPreviousError([], false);
    this.hideCommonError();
  }

  // To revert changes
  revertToPreviousError(element: any, isSingleLine) {
    if (element && element != null && this.eaModifyProductDSCopy.length > 0 && this.eaAddProductDS.data.length > 0) {
      if (element && element != null && isSingleLine) {
        // get old data
        let oldLineValue = this.eaModifyProductDSCopy.filter(x => x.itemID == element.itemID)[0];

        // delete data from storage
        this.saveInStorage(element);

        // get current object index
        const currentLineIndex = this.eaAddProductDS.data.findIndex(x => x.rowId == element.rowId);

        // replace current with old object if exist
        if (currentLineIndex != -1) {
          this.eaAddProductDS.data[currentLineIndex] = JSON.parse(JSON.stringify(oldLineValue));
          this.bindDataSource(this.eaAddProductDS.data, false);

          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != oldLineValue.rowId);

          // to hide one error after revert changes
          this.showHideLineError(oldLineValue.rowId);
          this.getCommonErrors(this.errorMsgs);
        }
      }
      else {
        // To hide all errors after revert all changes
        this.eaAddProductDS.data.forEach(x => {
          if (x.lineErrors.errors.length != 0) {
            var index = x.lineErrors.rowId - 1;
            let oldLineValue = this.eaModifyProductDSCopy.filter(y => y.itemID == x.itemID)[0];
            this.saveInStorage(x);
            this.eaAddProductDS.data[index] = JSON.parse(JSON.stringify(oldLineValue));
            this.showHideLineError(index);
          }
        });

        this.bindDataSource(this.eaAddProductDS.data, false);
        // To hide common error msg
        this.errorMsgs = new Array();
      }
    }
  }

  // Hide and show error line error
  showHideLineError(errorId: number) {
    if (errorId > 0) {
      const errorDiv = $('#error_' + errorId.toString());
      if (errorDiv) {
        errorDiv.hide();
      }
    }
    else {
      if (this.errorMsgs && this.errorMsgs.length > 0) {
        this.errorMsgs.forEach(x => {
          const errorDiv = $('#error_' + x.rowId.toString());
          if (errorDiv) {
            errorDiv.show();
          }
        });
      }
    }
  }
  // Show the next error
  nextError() {
    this.index = this.errorMsgs.findIndex(x => x.rowId == this.nextErrorId) + 1;
    if (this.errorMsgs.indexOf(this.errorMsgs[this.index]) != -1) {
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = this.index + 1;
      $('#orderView1').scrollTop = 0;
      if ($('#error_' + this.nextErrorId.toString()).offset()) {
        const nextOffset = $('#error_' + this.nextErrorId.toString()).offset().top;
        $('#orderView1').animate({ scrollTop: nextOffset }, 1000);
      }
    }
    else {
      this.index = 0;
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = 1;
      $('#orderView1').scrollTop = 0;
      $('#orderView1').animate({ scrollTop: 0 }, 1000);
    }
  }

  // Hide common error
  hideCommonError() {
    this.showErrorBlock
  }

  // Close the Add ea Page
  onCancel() {
    this.eaAddProductSliderModelService.close()
  }

  // Count of Total Ea units
  setCount() {
    let totalEaUnitsLocal = 0;
    this.globalKey.Values.map((x) => {
      totalEaUnitsLocal += parseInt(x.eaUnits)
    });
    this.totalEaUnits = totalEaUnitsLocal;
  }

  // Show Hide Update Button
  showHideUpdateBtn(): boolean {
    if ((!this.errorMsgs || this.errorMsgs.length == 0) && this.totalEaUnits > 0) {
      this.isupdate = false;
    }
    else {
      this.isupdate = true;
    }
    return this.isupdate;
  }
  // Get EA Add Products

  getEaProductsList() {
    $('#orderView1').animate({
      scrollTop: 0
    }, 'slow');

    this.loaderService.setLoaderStatus(true);
    this.errorMsgs = new Array();
    this.getCommonErrors(this.errorMsgs);
    var postData = {
      shipToAccount: this.accountNo,
      companyCode: this.companyCode,
      cropYear: this.cropYear,
      productLine: this.eaAddFilters ? this.eaAddFilters.productLine : '',
      packageSize: this.eaAddFilters ? this.eaAddFilters.packageSize : '',
      seedSize: this.eaAddFilters ? this.eaAddFilters.seedSize : '',
      marketingBrand: this.eaAddFilters ? this.eaAddFilters.marketingBrand : '',
      technology: this.eaAddFilters ? this.eaAddFilters.technology : '',
      treatment: this.eaAddFilters ? this.eaAddFilters.treatment : '',
      itemNumber: this.eaAddFilters ? this.eaAddFilters.itemNumber : '',
      productName: this.eaAddFilters ? this.eaAddFilters.productName : '',
      displayEAEligibleUnits: this.isDisplayDealerUnitsChecked
    };
    var localdata = this.globalKey.Values;
    this.subscription.push(this.dealerService.getDealerOrderEaItems(postData)
      .subscribe((result: any) => {
        if (result != null && result.length > 0) {
          let newRowId: Number = 0;
          result.forEach((x) => {
            if (localdata) {
              localdata.forEach((y) => {
                if (y.itemID == x.itemID) {
                  x.eaUnits = y.eaUnits;
                }
              })
            }
            newRowId = +newRowId + 1;
            x.rowId = +newRowId;
            x.totalRows = 2;
            x.lineErrors = { 'rowId': x.rowId, 'errors': [] };
          });
          this.eaAddProductDS = new MatTableDataSource(result);
          this.bindDataSource(result, true);
        }
        else {
          this.eaAddProductDS = new MatTableDataSource([]);
          this.bindDataSource([], true);
        }
        this.loaderService.setLoaderStatus(false);
      }, (error => {
        this.loaderService.setLoaderStatus(false);
      })));
  }

  setFilterDropDownData() {
    // MarketingBrand master data
    if (this.localStorageService.get(MasterConstants.MARKETING_BRAND_MASTER_LIST)) {
      this.filterOptionsData.find((x) => x.key == 'marketingBrand').controlData = JSON.parse(this.localStorageService.get(MasterConstants.MARKETING_BRAND_MASTER_LIST));
    }

    // SeedSize master data
    if (this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST)) {
      this.filterOptionsData.find((x) => x.key == 'seedSize').controlData = JSON.parse(this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST));
    }

    // PackageSize master data
    if (this.localStorageService.get(MasterConstants.PACKAGE_SIZE_MASTER_LIST)) {
      this.filterOptionsData.find((x) => x.key == 'packageSize').controlData = JSON.parse(this.localStorageService.get(MasterConstants.PACKAGE_SIZE_MASTER_LIST));
    }

    // Technology master data
    if (this.localStorageService.get(MasterConstants.TECHNOLOGY_MASTER_LIST)) {
      this.filterOptionsData.find((x) => x.key == 'technology').controlData = JSON.parse(this.localStorageService.get(MasterConstants.TECHNOLOGY_MASTER_LIST));
    }
    // Treatment master data
    if (this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST)) {
      this.filterOptionsData.find((x) => x.key == 'treatment').controlData = JSON.parse(this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST));
    }

    // Item Number master data
    this.subscription.push(this.commonService.getItemNumbers().subscribe((result: any) => {
      this.filterOptionsData.find((x) => x.key == 'itemNumber').controlData =
        result;
    }));

    // ProductLine master data
    if (this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST)) {
      this.filterOptionsData.find((x) => x.key == 'productLine').controlData = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST));
    }
  }

  // Validation for number only input field
  keyPressNumbers(event) {
    const numbers = /^[-+]?[0-9]+$/;
    if (!numbers.test(event.key)) {
      return false;
    }
  }
  ngAfterViewInit(): void {
  }

  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
